<template>
    <div class="sub-visual-full fade text-center color-white" :style="'background-image:url('+ bg +');'">
        <div class="sub-visual__video-wrap">
            <video v-if="video" loop autoplay playsinline muted :poster="bg" class="sub-visual__video">
                <source :src="video" type="video/mp4">
                <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
            </video>
        </div>
        <v-container>
            <slot/>
        </v-container>
        <scroll-ani v-if="scroll !== 'false'"></scroll-ani>
    </div>
</template>

<script>
import ScrollAni from "@/components/client/sub/sub-scroll-ani.vue";

export default{
    props : {
        bg : {type :String, default : ""},
        video : {type :String, default : ""},
        scroll : {type :String, default : ""},
    },
    components: {
        ScrollAni
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.sub-visual-full{
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
}

.sub-visual__video-wrap{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
}

.sub-visual__video{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.sub-visual__video-wrap::after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.text-ani-wrap{
    margin-top: -10px;
}

.text-ani {
    padding-top: 10px;
    overflow: hidden;
    display:block;
}

.text-ani-wrap .text-ani:not(:first-child){
    margin-top: -10px;
}

.text-ani >*{
    display:block;
    opacity:0;
    transform:translateY(100%);
    animation:textAni 1s ease forwards;
}

.text-ani:nth-child(1) >* {
	animation-delay: 0.2s;
}
.text-ani:nth-child(2) >* {
	animation-delay: 0.4s;
}
.text-ani:nth-child(3) >* {
	animation-delay: 0.6s;
}
.text-ani:nth-child(4) >* {
	animation-delay: 0.8s;
}

@keyframes textAni{
	0% {
		opacity:0;
		transform:translateY(100%);
	}
	100% {
		opacity:1;
		transform:translateY(0);
	}
}

.sub-visual-full h2{
    font-size: 3.2rem;
    line-height: 44px;
}

@media (min-width:576px){
}
@media (min-width:768px){
    .sub-visual-full h2{
        font-size: 4.6rem;
        line-height: 60px;
    }
}
@media (min-width:1024px){
    .sub-visual-full h2{
        font-size: 6rem;
        line-height: 76px;
    }
}
@media (min-width:1200px){
}

</style>